import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DevicesStore } from '@store';

import { CascadeDevicesBadge } from './cascade-devices-badge.model';

@Pipe({
  name: 'cascadeDevicesBadge',
})
export class CascadeDevicesBadgePipe implements PipeTransform {
  constructor(private devicesStore: DevicesStore, private translateService: TranslateService) {}

  transform(gatewaySerial: string): Observable<CascadeDevicesBadge> {
    return this.devicesStore.getCascadeDevicesNameForSpecificGateway(gatewaySerial).pipe(
      map((names) => names.map((name) => this.translateService.instant(name))),
      map((names) => ({ names: names.join(', ') + '.', count: names.length }))
    );
  }
}
